<template>
  <div class="user-form">
    <form class="form user-form__body" @submit.stop.prevent="formOnsubmit()">
      <!--begin: Wizard Step 1-->
      <div
        class="pb-5"
        data-wizard-type="step-content"
        data-wizard-state="current"
      >
        <h5 class="user-form__title font-weight-bolder text-dark font-size-h6 font-size-h3-lg">
          {{title}}
        </h5>
        <div class="row user-form__grid">
          <div class="col-12 col-lg-4 user-form__photo-column">
            <b-form-group id="input-group-photo" class="user-form__photo-group">
              <label>Foto profil</label>
              <div class="user-form__avatar-shell">
                <div
                  class="image-input image-input-outline user-avatar-input"
                  id="kt_profile_avatar"
                >
                  <div class="image-input-wrapper">
                    <img :src="photo" alt="Pratinjau foto pengguna" />
                  </div>
                  <div class="user-avatar-actions">
                    <label
                      class="btn btn-icon user-avatar-action user-avatar-action--edit"
                      title="Ganti foto"
                      aria-label="Ganti foto pengguna"
                    >
                      <i class="fa fa-pen icon-sm"></i>
                      <input
                        type="file"
                        name="profile_avatar"
                        accept=".png, .jpg, .jpeg"
                        @change="onFileChange($event)"
                      />
                      <input type="hidden" name="profile_avatar_remove" />
                    </label>
                    <button
                      type="button"
                      class="btn btn-icon user-avatar-action user-avatar-action--remove"
                      title="Hapus foto"
                      aria-label="Hapus foto pengguna"
                      @click="onRemove"
                    >
                      <i class="ki ki-bold-close icon-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
              <small class="user-form__photo-help">PNG atau JPG, maksimal 2 MB.</small>
            </b-form-group>
          </div>

          <div class="col-12 col-lg-8 user-form__fields-column">

            <b-form-group
              id="input-group-name"
              label="Nama"
              label-for="input-name"
            >
              <b-form-input
                id="input-name"
                v-model="form.name"
                placeholder="Nama"
              ></b-form-input>
              <small class="text-danger">{{ error.name }}</small>
            </b-form-group>

            <b-form-group id="input-group-address">
              <label for="input-address">Alamat</label>
              <b-form-textarea
                id="input-address"
                v-model="form.address"
                placeholder="Alamat"
                rows="4"
                max-rows="8"
              ></b-form-textarea>
              <small class="text-danger">{{ error.address }}</small>
            </b-form-group>

            <b-form-group
              id="input-group-phone"
              label="Telepon"
              label-for="input-phone"
            >
              <b-form-input
                id="input-phone"
                v-model="form.phone"
                placeholder="Telepon"
              ></b-form-input>
              <small class="text-danger">{{ error.phone }}</small>
            </b-form-group>

            <b-form-group
              id="input-group-email"
              label="Email"
              label-for="input-email"
            >
              <b-form-input
                id="input-email"
                v-model="form.email"
                placeholder="Email"
              ></b-form-input>
              <small class="text-danger">{{ error.email }}</small>
            </b-form-group>

            <!-- Text input -->
            <b-form-group
              id="input-group-password"
              label="Password"
              label-for="input-password"
              v-if="purpose == 'add'"
            >
              <b-input-group class="user-password-control">
                <template #prepend>
                  <b-input-group-text
                    class="user-password-toggle"
                    @click="
                      passwordIsVisible == 'password'
                        ? (passwordIsVisible = 'text')
                        : (passwordIsVisible = 'password')
                    "
                  >
                    <div v-if="passwordIsVisible == 'password'">
                      <b-icon-eye-slash></b-icon-eye-slash>
                    </div>
                    <div v-if="passwordIsVisible == 'text'">
                      <b-icon-eye></b-icon-eye>
                    </div>
                  </b-input-group-text>
                </template>
                <b-form-input
                  id="input-password"
                  v-model="form.password"
                  placeholder="Password"
                  :type="passwordIsVisible"
                ></b-form-input>
              </b-input-group>
                <small class="text-danger">{{error.password}}</small>
            </b-form-group>

            <b-form-group
              id="input-group-role"
              label="Peran"
              label-for="input-role"
            >
              <treeselect
                v-model="form.role_id"
                :multiple="false"
                placeholder="Pilih Peran"
                :options="roles"
              />
              <small class="text-danger">{{ error.role_id }}</small>
            </b-form-group>

          </div>
        </div>
      </div>
      <!--end: Wizard Step 1-->

      <!--begin: Wizard Actions -->
      <div class="d-flex justify-content-between border-top pt-10">
        <div>
          <b-button type="submit" variant="primary">Simpan</b-button>
          <b-button
            type="button"
            class="ml-2"
            variant="default"
            @click="$router.push(routeBack)"
          >
            Batal
          </b-button>
        </div>
      </div>
      <!--end: Wizard Actions -->
    </form>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  props: {
    routeBack: String,
    roleId: String,
    form: Object,
    routePost: String,
    currentPhoto: String,
    purpose: String,
    secondPurpose: String,
    title: String
  },
  data() {
    return {
      error: {
        address: "",
        email: "",
        email2: "",
        name: "",
        nickname: "",
        phone: "",
        photo: "",
        description: "",
        role_id: "",
        password: "",
        registration_number: "",
      },
      roles: [],
      current_photo: "/img/default/default-user.svg",
      default_photo: "/img/default/default-user.svg",
      majors: [],
      // other
      passwordIsVisible: "password",
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        this.form.photo = e.target.files[0];

        reader.onload = (event) => {
          this.current_photo = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    onRemove() {
      this.current_photo = null;
      this.form.photo = "";
    },

    async getRoleOption() {
      let response = await module.setTreeSelect("roles");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.roles = response.data;
        this.roles.unshift({
          label: "Pilih Peran",
          id: "",
          isDisabled: true,
        });
      }
    },

    async formOnsubmit() {
      
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
      }
      // Make Request
      let response = await module.submit(formData, this.routePost);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$emit("successPost");
      }
    },
  },
  mounted() {
    this.getRoleOption();

    this.current_photo = this.form.photo;
  },
  computed: {
    photo() {
      return this.current_photo == null
        ? this.default_photo
        : this.current_photo;
    },
  },
  watch: {
    form: function (newVal, oldVal) {
      // watch it
      //("Form changed: ", newVal, " | was: ", oldVal);
      this.current_photo = this.form.photo;
      //   this.default_photo = this.form.photo
    },
  },
};
</script>

<style scoped>
.user-form {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
}

.user-form__title {
  margin-bottom: 28px !important;
  color: var(--saas-heading) !important;
  font-size: 22px !important;
  letter-spacing: -0.025em;
}

.user-form__grid {
  margin-right: -18px;
  margin-left: -18px;
}

.user-form__photo-column,
.user-form__fields-column {
  padding-right: 18px;
  padding-left: 18px;
}

.user-form__photo-group {
  position: sticky;
  top: 24px;
}

.user-form__avatar-shell {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 2px;
}

.user-avatar-input {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  padding: 7px;
  background: var(--saas-surface-2);
  border: 1px solid var(--saas-border) !important;
  border-radius: 22px !important;
  box-shadow: var(--saas-shadow-xs);
}

.image-input-wrapper {
  width: 220px !important;
  height: 220px !important;
  overflow: hidden;
  background: var(--saas-surface-3) !important;
  border: 0 !important;
  border-radius: 17px !important;
}

.image-input-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-avatar-action {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 36px !important;
  min-width: 36px !important;
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 !important;
  color: var(--saas-brand-2) !important;
  background: var(--saas-surface-3) !important;
  border: 1px solid var(--saas-border-strong) !important;
  border-radius: 11px !important;
  box-shadow: 0 7px 18px rgba(0, 0, 0, 0.16) !important;
}

.user-avatar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 2px 1px;
}

.user-avatar-action input[type="file"],
.user-avatar-action input[type="hidden"] {
  display: none !important;
}

.user-avatar-action i {
  color: inherit !important;
}

.user-avatar-action:hover {
  color: var(--saas-accent) !important;
  background: var(--saas-accent-soft) !important;
  border-color: var(--saas-accent) !important;
}

.user-avatar-action--edit {
  position: static !important;
  margin: 0 !important;
}

.user-avatar-action--remove {
  position: static !important;
  margin: 0 !important;
  color: #dc6473 !important;
}

.user-avatar-action--remove:hover {
  color: #ff8b98 !important;
  background: var(--saas-danger-soft) !important;
  border-color: #b94c5c !important;
}

.user-form__photo-help {
  display: block;
  margin-top: 12px;
  color: var(--saas-muted) !important;
  font-size: 11px;
}

.user-form .form-group {
  margin-bottom: 18px !important;
}

.user-form label,
.user-form legend {
  margin-bottom: 7px !important;
  color: var(--saas-text) !important;
  font-size: 12px !important;
  font-weight: 650 !important;
}

.user-form .form-control,
.user-form .input-group-text,
.user-form .vue-treeselect__control {
  min-height: 44px !important;
}

.user-form textarea.form-control {
  min-height: 112px !important;
  resize: vertical;
}

.user-password-toggle {
  display: inline-flex !important;
  flex: 0 0 46px;
  width: 46px !important;
  min-width: 46px !important;
  height: 44px !important;
  min-height: 44px !important;
  padding: 0 !important;
  justify-content: center;
  color: var(--saas-brand-2) !important;
  background: var(--saas-surface-2) !important;
  border: 1px solid var(--saas-border) !important;
  border-right: 0 !important;
  border-radius: var(--saas-radius-sm) 0 0 var(--saas-radius-sm) !important;
  cursor: pointer;
}

.user-password-toggle:hover {
  color: var(--saas-accent) !important;
  background: var(--saas-accent-soft) !important;
}

.user-password-control {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}

.user-password-control .input-group-prepend {
  display: flex;
  margin-right: -1px !important;
}

.user-password-control .form-control {
  position: relative;
  z-index: 1;
  min-width: 0;
  height: 44px !important;
  border-radius: 0 var(--saas-radius-sm) var(--saas-radius-sm) 0 !important;
}

.user-password-control .form-control:focus {
  z-index: 3;
}

.user-form .border-top {
  margin-top: 12px;
  padding-top: 24px !important;
  border-color: var(--saas-border) !important;
}

@media (max-width: 991.98px) {
  .user-form__photo-group {
    position: static;
    margin-bottom: 28px !important;
  }
}

@media (max-width: 575.98px) {
  .user-form__grid {
    margin-right: 0;
    margin-left: 0;
  }

  .user-form__photo-column,
  .user-form__fields-column {
    padding-right: 0;
    padding-left: 0;
  }

  .user-form__title {
    margin-bottom: 22px !important;
    font-size: 19px !important;
  }

  .image-input-wrapper {
    width: 190px !important;
    height: 190px !important;
  }
}
</style>
